'use strict';

// this should be the entry point to your library
module.exports = {
  VerticalTimeline: require('./VerticalTimeline').default,
  VerticalTimelineElement: require('./VerticalTimelineElement').default
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-vertical-timeline-component/dist-es6/index.js
// module id = 409
// module chunks = 0